import React from 'react';
import styled from 'styled-components';
import tw from 'twin.macro';
//eslint-disable-next-line
import { css } from 'styled-components/macro';

import Header from '../headers/light.js';

import { ReactComponent as SvgDecoratorBlob1 } from '../../images/svg-decorator-blob-1.svg';
import DesignIllustration from '../../images/hero.svg';
import MazenLogo from 'images/mazen.jpeg';
import ConceptLogo from 'images/concept-school-logo.png';
import DarearqmLogo from 'images/darearqmLogo.png';

const Container = tw.div`relative`;
const TwoColumn = tw.div`flex flex-col lg:flex-row lg:items-center max-w-screen-xl mx-auto py-20 md:py-24 gap-2`;
const LeftColumn = tw.div`relative lg:w-5/12 text-center max-w-lg mx-auto lg:max-w-none lg:text-left`;
const RightColumn = tw.div`relative mt-12 lg:mt-0 flex-1 flex h-full flex-col justify-center`;

const Heading = tw.h1`font-bold text-3xl md:text-3xl lg:text-4xl xl:text-5xl text-gray-900 leading-tight`;
const Paragraph = tw.p`my-5 lg:my-8 text-base xl:text-lg`;

const ImagesStrip = tw.div`flex items-center justify-start gap-6 my-2 py-1`;
const Image = tw.img`w-auto h-12 lg:w-auto lg:h-16 w-full opacity-75`;

const Actions = styled.div`
	${tw`relative max-w-md text-center mx-auto lg:mx-0`}
	input {
		${tw`sm:pr-48 pl-8 py-4 sm:py-5 rounded-full border-2 w-full font-medium focus:outline-none transition duration-300  focus:border-primary-500 hover:border-gray-500`}
	}
	button {
		${tw`w-full sm:absolute right-0 top-0 bottom-0 bg-primary-500 text-gray-100 font-bold mr-2 my-4 sm:my-2 rounded-full py-4 flex items-center justify-center sm:w-40 sm:leading-none focus:outline-none hover:bg-primary-900 transition duration-300`}
	}
`;

const IllustrationContainer = tw.div`flex h-full justify-center lg:justify-end items-center`;

// Random Decorator Blobs (shapes that you see in background)
const DecoratorBlob1 = styled(SvgDecoratorBlob1)`
	${tw`pointer-events-none opacity-5 absolute left-0 bottom-0 h-64 w-64 transform -translate-x-2/3 -z-10`}
`;

const CustomersLogoStrip = styled.div`
	${tw`mt-12 lg:mt-20`}
	p {
		${tw`uppercase text-sm lg:text-xs tracking-wider font-bold text-gray-500`}
	}
`;

export default ({ roundedHeaderButton, header, paragraph, imgSrc = DesignIllustration }) => {
	return (
		<>
			<Header roundedHeaderButton={roundedHeaderButton} />
			<Container>
				<TwoColumn>
					<LeftColumn>
						<Heading>
							{header}
							{/* Empowering Your Finances, <span tw='text-primaryy-500'>Ensuring Your Success.</span> */}
						</Heading>
						<Paragraph css={tw`text-justify pr-4`}>
							{paragraph}
							{/* We specialize in delivering top-notch financial auditing, taxation, and reporting solutions tailored to your needs. Our
							mission is to simplify complex financial processes, ensure compliance, and uncover opportunities for growth. Whether it’s
							streamlining your accounts or optimizing tax strategies, we’re here to help you achieve financial clarity and confidence.
							Let us be your trusted partner in building a stronger financial future. */}
						</Paragraph>
						{/* <Actions>
              <input type="text" placeholder="Your E-mail Address" />
              <button>Get Started</button>
            </Actions> */}
						<CustomersLogoStrip>
							<p>Our TRUSTED Clients</p>
							<ImagesStrip>
								<Image src={DarearqmLogo} />
								<Image src={MazenLogo} />
								<Image src={ConceptLogo} />
							</ImagesStrip>
							{/* <img src={CustomersLogoStripImage} alt='Our Customers' /> */}
						</CustomersLogoStrip>
					</LeftColumn>
					<RightColumn>
						<IllustrationContainer>
							<img tw='min-w-0 w-full max-w-lg xl:max-w-3xl' src={imgSrc} alt='Design Illustration' />
						</IllustrationContainer>
					</RightColumn>
				</TwoColumn>
				<DecoratorBlob1 />
			</Container>
		</>
	);
};
